import React, { useContext, useRef } from "react";

// import "./CustomerDetails.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";


import { accountService } from "../../services/accountService";
import LogicContext from "../../Context/LogicContext";
import NotificationContext from "../../Context/NotificationContext";

import { Dropdown } from "react-bootstrap";
import Tooltip from '@mui/material/Tooltip';
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import ChartAccountScroll from "./ChartAccountScroll";
import CurrencyFormat from 'react-currency-format';
import ForeignCurrencyTable from "../../components/ForeignCurrencyTable";
import BaseCurrencyTable from "../../components/BaseCurrencyTable";
import ChartOfAccountCurrency from "./ChartOfAccountCurrency";
import { useSearchParams } from "react-router-dom";
import {SetChartEdit,SetChartAccountData ,GetChartAccountData
} from '../../store/chartOfAccountAtom';
import { ArrowLeft, Plus, Trash2, Printer, Pencil, Ban, CheckCircle2 } from "lucide-react";
import StatusBadge from "../../generals/StatusBadge";

function ChartOfAccountDetailsPage() {


  const logicContext = useContext(LogicContext);
  const notificationContext = useContext(NotificationContext);
  const myPromiseModal = createModal(GeneralModal);


  const [searchParams] = useSearchParams();
  const needsReload = searchParams.get('reload');


  const [chartDetails, setChartDetails] = useState({});
  const [bcyList, setBcyList] = useState([]);
  const [showBaseCurr, setShowBaseCurr] = useState(true);
  const [defaultCurrencyId, setDefaultCurrencyId] = useState(0);
  const [selectedList, setSelectedList] = useState([]); 

    const setEditDetails = SetChartEdit();
    const setChartAccountData = SetChartAccountData();
    const getChartAccountData = GetChartAccountData();

    // Ref for the printable content
    const printableRef = useRef();

  const { chart_id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];


  useEffect(()=> {
    document.title ="Chart of account details"
    let isMounted = true;
    accountService.getChartOfAccountDetails(chart_id).then(response => {
      if(isMounted && response?.data !== undefined){
        setChartDetails(response.data['chart_of_accounts'][0]);
        setBcyList(response.data['BCY']);
      }
    });
    return () => {
      isMounted = false;
    };
  },[chart_id]);

 

  useEffect(() => {
    let isMounted = true;
    if (sessionStorage.getItem('reloadPage') === 'true') {
      sessionStorage.removeItem('reloadPage');
      loadTableData(isMounted);
    }
  
    if(getChartAccountData?.chart_of_accounts?.length < 1){
      loadTableData(isMounted);
    }
    return () => {
      isMounted = false;
    };
  }, [getChartAccountData?.chart_of_accounts?.length]);


   const loadTableData = (isMounted) => {
    accountService.getChartOfAccount().then(res => {
      if(isMounted && res?.data !== undefined){
        setChartAccountData(res?.data);

      }
  });
  
    }

  // Custom print function similar to other components
  const printSection = (elementRef, title = 'Chart of Account Details') => {
    if (!elementRef.current) {
      console.error('Print reference not found');
      return;
    }

    const printContents = elementRef.current.innerHTML;
    const originalContents = document.body.innerHTML;
    
    // Replace page content with selected section
    document.body.innerHTML = `
      <html>
        <head>
          <title>${title}</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              margin: 20px; 
              line-height: 1.6;
              color: #333;
            }
            table { 
              border-collapse: collapse; 
              width: 100%; 
              margin: 20px 0;
            }
            th, td { 
              border: 1px solid #ddd; 
              padding: 12px 8px; 
              text-align: left; 
            }
            th { 
              background-color: #f8f9fa; 
              font-weight: bold;
              color: #495057;
            }
            .print-header { 
              text-align: center; 
              margin-bottom: 30px; 
              border-bottom: 2px solid #6c757d;
              padding-bottom: 20px;
            }
            .print-header h1 {
              color: #6c757d;
              margin: 0;
              font-size: 28px;
            }
            .account-summary { 
              background-color: #f8f9fa; 
              padding: 20px; 
              margin: 20px 0; 
              border-left: 4px solid #6c757d;
              border-radius: 5px;
            }
            .balance-highlight {
              font-size: 24px;
              font-weight: bold;
              color: #28a745;
              margin: 15px 0;
            }
            .account-info {
              background-color: #e9ecef;
              padding: 15px;
              margin: 15px 0;
              border-radius: 8px;
            }
            .account-details {
              margin: 10px 0;
              font-size: 14px;
            }
            .account-details strong {
              color: #495057;
            }
            .currency-section {
              margin: 20px 0;
              border-top: 2px solid #dee2e6;
              padding-top: 15px;
            }
            .transactions-header {
              font-size: 18px;
              font-weight: bold;
              color: #495057;
              margin: 20px 0 10px 0;
              border-bottom: 1px solid #dee2e6;
              padding-bottom: 5px;
            }
            .text-right {
              text-align: right;
            }
            .text-center {
              text-align: center;
            }
            .font-bold {
              font-weight: bold;
            }
            .mb-3 {
              margin-bottom: 1rem;
            }
            .mt-3 {
              margin-top: 1rem;
            }
            .status-active {
              color: #28a745;
              font-weight: bold;
            }
            .status-inactive {
              color: #dc3545;
              font-weight: bold;
            }
            /* Hide any buttons or interactive elements */
            button, .btn, .dropdown, .cursor, .show-cursor {
              display: none !important;
            }
            /* Hide navigation elements */
            .MuiSvgIcon-root, .p-1\\.5 {
              display: none !important;
            }
            /* Print-specific adjustments */
            @media print {
              body {
                margin: 0;
                padding: 15px;
                font-size: 12px;
              }
              .page-break {
                page-break-before: always;
              }
              .no-print {
                display: none !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-header">
            <h1>Chart of Account Details</h1>
            <p>Account: ${chartDetails?.Account_Name || 'N/A'}</p>
            <p>Account ID: ${chartDetails?.Account_Id || chart_id}</p>
          </div>
          ${printContents}
        </body>
      </html>
    `;
    
    // Trigger print dialog
    window.print();
    
    // Restore original content
    document.body.innerHTML = originalContents;
    window.location.reload(); // Reload to restore React functionality
  };

  // Print handler
  const handlePrint = () => {
    printSection(printableRef, `Chart of Account - ${chartDetails?.Account_Name || 'Details'}`);
  };

  function viewItemDetails(id) {
    navigate( `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}` );
    getSubDetailFromServer(id);
  }



  function onSelection(list){
    let tempList = []
    list.forEach((parentAcc)=> {
      if(parentAcc.checked === true) {
        tempList.push(parentAcc)
      };
      if(parentAcc?.children?.length){
        parentAcc?.children.forEach((child)=> {
          if(child.checked) tempList.push(child);
          if(child?.children?.length){
            child.children.forEach((grandChild)=> {
              if(grandChild.checked) tempList.push(grandChild);
            })
          }
        })
      }
    })
    setSelectedList(tempList)
  }


  function getSubDetailFromServer(id) {
    accountService.getChartOfAccountDetails(id).then(response => {
      if(response?.data !== undefined){
        setChartDetails(response.data['chart_of_accounts'][0]);
        setBcyList(response.data['BCY']);
      }
    });
  }


  const modifychartAccount = async () => {
    await myPromiseModal({ title: "Modify Account!", body: " Do you want to modify selected Account?",
    showInput:false, placeHolder:''}).then((res) => {
      if(res.decision === true){
        setEditDetails(chartDetails);
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`)
      }
    });
  };


  const addNewchartAccount = ()=> {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`)
  }


  function  onCurrencySelect(val){
    setDefaultCurrencyId(val)
  }

  const viewAccount = (id) => {
    const customerRoute = `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`;
    // Option A: Open in new tab using window.open()
    window.open(customerRoute, '_blank');

  }


 async function  onChangeStatus(status){
    if(status === 'I'){
      let xml_string = `<root><a> <account_id> ${chart_id} </account_id> </a> </root>`;
      const option = 4;
      await myPromiseModal({ title: "Mark as InActive?",
      body: " Please confirm your action.",showInput:false, placeHolder:''
     }).then(result => {
      if (result.decision === true){
        accountService.updateAccountStatus({xml_string, option}).then(res => {
          if(res?.data !== undefined){
            const {message_text} = res.data[0]
            logicContext.showToast(message_text, 'success');
           return getSubDetailFromServer(chart_id);
          }
        }).catch((err)=> {
          // logicContext.showToast('Error', 'error');
        });
      }
     });

    }else if(status === 'A'){
      let xml_string = `<root><a> <account_id> ${chart_id} </account_id> </a> </root>`;
      const option = 5;
      await myPromiseModal({ title: "Mark as InActive?",
      body: " Please confirm your action.",showInput:false, placeHolder:''
     }).then(result => {
      if (result.decision === true){
        accountService.updateAccountStatus({xml_string, option}).then(res => {
            if(res?.data !== undefined){
              const {message_text} = res.data[0]
              logicContext.showToast(message_text, 'success');
             return getSubDetailFromServer(chart_id);
            }
        }).catch((err)=> {
          // logicContext.showToast('Error', 'error');
        });
      }
     });

    }else if(status === 'DELETE'){
      let xml_string = `<root><a> <account_id> ${chart_id} </account_id> </a> </root>`;
      const option = 3;
      await myPromiseModal({ title: `Do you want to delete  ${chartDetails.Account_Name}?`,
      body: " Deleted records cannot be recovered, do you want to continue?",
      showInput:false, placeHolder:''}).then(result => {
      if (result.decision === true){
        if(bcyList?.length > 0){
          return logicContext.showToast('this account already have a dependable transaction!', 'error')
        }

        accountService.updateAccountStatus({xml_string, option}).then(res => {
            if(res?.data !== undefined){
              const {message_text} = res.data[0]
              logicContext.showToast(message_text, 'info');
              notificationContext.reloadChartList();
             return navigate(-1);
            }
        }).catch((err)=> {
          // logicContext.showToast('Error', 'error');
        });
      }
     });
      
    }
  }


  async function bulkActions(message, option) {
    await myPromiseModal({
      title: message + '?',
      body: `Do you want to  ${message}?`,showInput:false, placeHolder:''
    }).then((result) => {
     
      if(result.decision === true){
        let temp = '';
        selectedList.map(item => {
          temp += `<a> <account_id> ${item.Account_Id} </account_id> </a>`
        });
  
        let xml_string = `<root> ${temp} </root>`;
        accountService.updateAccountStatus({xml_string, option}).then(res => {
          if(res?.data !== undefined){
            const {message_text} = res.data[0];
            logicContext.showToast(message_text, 'success');
           return  loadTableData();
        
          }
      }).catch((err)=> {
        // logicContext.showToast('Error', 'error');
      });
      }
  
    });

  }




 
  const isActive = chartDetails?.Account_Status_Id === "A";
  const iconBtn =
    "flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-800";

  return (
    <>
      <section className="mt-2 px-3 pb-12">
        <div className="mx-auto max-w-6xl">
          {/* Toolbar */}
          <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
            <div className="flex min-w-0 items-center gap-3">
              <button
                onClick={() => navigate(-1)}
                className={iconBtn}
                aria-label="Go back"
              >
                <ArrowLeft className="h-5 w-5" />
              </button>
              <div className="min-w-0">
                <h1 className="truncate text-xl font-semibold text-gray-800">
                  {chartDetails?.Account_Name || "—"}
                </h1>
                <p className="truncate text-sm text-gray-500">
                  {chartDetails?.Account_Type_Name}
                  {chartDetails?.Account_Main_Name
                    ? ` · ${chartDetails?.Account_Main_Name}`
                    : ""}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2">
              {selectedList?.length > 0 && (
                <Dropdown>
                  <Dropdown.Toggle
                    style={{
                      backgroundColor: "#E5E5E5",
                      border: "none",
                      color: "#45444B",
                      fontSize: "12px",
                      height: "36px",
                      borderRadius: "8px",
                    }}
                    id="dropdown-basic"
                  >
                    Bulk Actions
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => bulkActions("Mark selection(s) as Active", 4)}
                    >
                      Mark as Active
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        bulkActions("Mark selection(s) as InActive", 5)
                      }
                    >
                      Mark as InActive
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => bulkActions("Delete selection(s) ", 3)}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}

              {isActive && (
                <button
                  onClick={() => onChangeStatus("A")}
                  className="inline-flex items-center gap-1.5 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-700 transition-colors hover:bg-amber-100"
                >
                  <Ban className="h-4 w-4" /> Mark inactive
                </button>
              )}
              {chartDetails?.Account_Status_Id === "I" && (
                <button
                  onClick={() => onChangeStatus("I")}
                  className="inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700"
                >
                  <CheckCircle2 className="h-4 w-4" /> Mark active
                </button>
              )}

              <Tooltip title="Add new account">
                <button onClick={addNewchartAccount} className={iconBtn}>
                  <Plus className="h-5 w-5" />
                </button>
              </Tooltip>
              <Tooltip title="Edit account">
                <button onClick={modifychartAccount} className={iconBtn}>
                  <Pencil className="h-[18px] w-[18px]" />
                </button>
              </Tooltip>
              <Tooltip title="Print details">
                <button onClick={handlePrint} className={iconBtn}>
                  <Printer className="h-[18px] w-[18px]" />
                </button>
              </Tooltip>
              <Tooltip title="Delete account">
                <button
                  onClick={() => onChangeStatus("DELETE")}
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 text-red-500 transition-colors hover:bg-red-50 hover:text-red-600"
                >
                  <Trash2 className="h-[18px] w-[18px]" />
                </button>
              </Tooltip>
            </div>
          </div>

          {/* Body: sidebar + content */}
          <div className="flex items-start gap-4">
            <ChartAccountScroll
              viewItemDetails={viewItemDetails}
              onSelection={onSelection}
            ></ChartAccountScroll>

            {/* Printable content wrapper */}
            <section className="w-full min-w-0" ref={printableRef}>
              <div className="account-summary rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
                <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
                  <div className="account-info min-w-0">
                    <div className="flex flex-wrap items-center gap-2.5">
                      <h2 className="truncate text-lg font-semibold text-gray-800">
                        {chartDetails?.Account_Name}
                      </h2>
                      <StatusBadge
                        statusId={chartDetails?.Account_Status_Id}
                        statusName={
                          chartDetails?.Account_Status_Name ||
                          (isActive ? "Active" : "Inactive")
                        }
                      />
                    </div>

                    <dl className="mt-4 space-y-2.5 text-sm">
                      <div className="account-details flex gap-3">
                        <dt className="w-28 shrink-0 text-gray-500">Account ID</dt>
                        <dd className="font-medium text-gray-800">
                          {chartDetails?.Account_Id}
                        </dd>
                      </div>
                      <div className="account-details flex gap-3">
                        <dt className="w-28 shrink-0 text-gray-500">
                          Account Type
                        </dt>
                        <dd className="font-medium text-gray-800">
                          {chartDetails?.Account_Type_Name}
                        </dd>
                      </div>
                      <div className="account-details flex gap-3">
                        <dt className="w-28 shrink-0 text-gray-500">
                          Description
                        </dt>
                        <dd className="text-gray-700">
                          {chartDetails?.Account_Description || "—"}
                        </dd>
                      </div>
                    </dl>
                  </div>

                  {/* Balance panel */}
                  <div className="shrink-0 rounded-lg border border-gray-100 bg-gray-50 px-5 py-4 md:min-w-[220px] md:text-right">
                    <div className="text-xs font-medium uppercase tracking-wide text-gray-500">
                      Closing Balance
                    </div>
                    <div className="balance-highlight mt-1 text-2xl font-bold text-gray-900">
                      <CurrencyFormat
                        value={(
                          parseFloat(chartDetails?.Closing_Amount) || 0
                        ).toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={chartDetails?.Currency_Name_Short}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Transactions */}
              <div className="mt-4 rounded-xl border border-gray-200 bg-white shadow-sm">
                <div className="transactions-header flex flex-wrap items-center justify-between gap-3 border-b border-gray-100 px-6 py-4">
                  <h3 className="text-base font-semibold text-gray-800">
                    Recent Transactions
                  </h3>

                  <div className="currency-section flex flex-wrap items-center gap-3">
                    {showBaseCurr && (
                      <span className="text-sm font-medium text-gray-600">
                        Currency
                      </span>
                    )}
                    {showBaseCurr && (
                      <ChartOfAccountCurrency onCurrencySelect={onCurrencySelect} />
                    )}

                    <div className="inline-flex overflow-hidden rounded-lg border border-gray-200">
                      <button
                        className={`px-4 py-2 text-sm font-medium transition-colors ${
                          showBaseCurr
                            ? "bg-blue-600 text-white"
                            : "bg-white text-gray-600 hover:bg-gray-50"
                        }`}
                        onClick={() => setShowBaseCurr(true)}
                      >
                        FCY
                      </button>
                      <button
                        className={`border-l border-gray-200 px-4 py-2 text-sm font-medium transition-colors ${
                          !showBaseCurr
                            ? "bg-blue-600 text-white"
                            : "bg-white text-gray-600 hover:bg-gray-50"
                        }`}
                        onClick={() => setShowBaseCurr(false)}
                      >
                        BCY
                      </button>
                    </div>
                  </div>
                </div>

                <div className="overflow-x-auto p-4">
                  {showBaseCurr && (
                    <ForeignCurrencyTable
                      viewAccount={viewAccount}
                      bcyList={bcyList}
                      defaultCurrId={defaultCurrencyId}
                    />
                  )}
                  {!showBaseCurr && (
                    <BaseCurrencyTable viewAccount={viewAccount} bcyList={bcyList} />
                  )}
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </>
  );
}

export default ChartOfAccountDetailsPage;